import React, { PropsWithChildren, ReactNode, useRef, useState } from "react";
import { useOnClickOutside } from "usehooks-ts";
import { useEscapeKey } from "../hooks/useEscapeKey";
import classNames from "classnames";

export const DetailsHover: React.FC<
  PropsWithChildren<{
    summary?: ReactNode;
  }>
> = ({ summary, children }) => {
  const [open, setOpen] = useState(false);
  const close = () => setOpen(false);
  const ref = useRef(null);
  useOnClickOutside(ref, close);
  useEscapeKey(close);
  return (
    <details
      className={"relative group"}
      ref={ref}
      open={open}
      onMouseLeave={close}
      onMouseEnter={() => setOpen(true)}
    >
      {summary && (
        <summary className={"list-none [&::-webkit-details-marker]:hidden"}>
          {summary}
        </summary>
      )}
      <div
        className={classNames(
          "absolute top-full left-0 z-10",
          "block",
          "p-4",
          "min-w-min whitespace-nowrap",
          "bg-white text-primary",
          "transition-all opacity-0 group-open:opacity-100 group-hover:opacity-100",
        )}
      >
        {children}
      </div>
    </details>
  );
};
